function Icon(props) {
  return (
    <svg
      width={147}
      height={42}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.554 42H5.446C2.445 42 0 39.633 0 36.75V5.25C0 2.357 2.445 0 5.446 0h136.108C144.553 0 147 2.357 147 5.25v31.5c0 2.883-2.447 5.25-5.446 5.25z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.554.84c2.517 0 4.578 1.983 4.578 4.41v31.5c0 2.427-2.047 4.41-4.578 4.41H5.446c-2.517 0-4.578-1.983-4.578-4.41V5.25C.868 2.823 2.915.84 5.446.84h136.108zm0-.84H5.446C2.445 0 0 2.367 0 5.25v31.5C0 39.643 2.445 42 5.446 42h136.108c2.999 0 5.446-2.357 5.446-5.25V5.25c0-2.883-2.447-5.25-5.446-5.25z"
        fill="#A6A6A6"
      />
      <path
        d="M77.44 13.893c-.982 0-1.81-.332-2.463-.987a3.306 3.306 0 01-.996-2.409c0-.955.336-1.764.996-2.406.651-.655 1.479-.987 2.46-.987.971 0 1.799.332 2.464.987a3.3 3.3 0 01.995 2.406c-.01.959-.346 1.768-.995 2.407-.652.66-1.48.99-2.46.99zm-29.209 0c-.96 0-1.793-.327-2.474-.974-.676-.644-1.02-1.458-1.02-2.419 0-.961.344-1.775 1.02-2.42.668-.646 1.5-.974 2.474-.974.476 0 .938.092 1.382.278.435.18.79.427 1.052.728l.065.076-.733.696-.076-.086c-.413-.477-.968-.71-1.7-.71-.655 0-1.226.226-1.696.67-.474.448-.714 1.035-.714 1.745 0 .71.24 1.296.714 1.743.47.446 1.04.67 1.695.67.698 0 1.285-.224 1.742-.67.27-.261.438-.628.497-1.091h-2.35v-.98h3.36l.013.09c.024.164.048.335.048.492 0 .903-.28 1.633-.838 2.173-.633.639-1.46.963-2.46.963zm38.836-.138h-1.035L82.859 8.84l.028.885v4.027H81.85V7.245h1.181l.033.05 2.983 4.63-.027-.883V7.245h1.046v6.51zm-17.41 0h-1.05v-5.53h-1.82v-.98h4.687v.98h-1.82v5.53h.003zm-3.724 0h-1.046v-6.51h1.046v6.51zm-5.882 0h-1.046v-5.53h-1.82v-.98h4.686v.98h-1.82v5.53zm-3.529-.01H52.51v-6.5h4.013v.98H53.56v1.785h2.674v.97H53.56v1.785h2.963v.98zm19.223-1.512c.467.453 1.035.681 1.695.681.679 0 1.233-.222 1.696-.68.46-.446.692-1.03.692-1.734s-.233-1.29-.69-1.733a2.359 2.359 0 00-1.695-.681c-.679 0-1.233.222-1.693.68-.46.446-.692 1.03-.692 1.734s.23 1.29.686 1.733z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.884 22.843c-2.556 0-4.627 1.878-4.627 4.468 0 2.566 2.085 4.466 4.627 4.466 2.555 0 4.627-1.89 4.627-4.466 0-2.59-2.072-4.468-4.627-4.468zm0 7.165c-1.398 0-2.602-1.121-2.602-2.708 0-1.61 1.207-2.707 2.602-2.707 1.398 0 2.602 1.097 2.602 2.707.002 1.597-1.204 2.707-2.602 2.707zm-10.095-7.165c-2.556 0-4.627 1.878-4.627 4.468 0 2.566 2.085 4.466 4.627 4.466 2.555 0 4.627-1.89 4.627-4.466 0-2.59-2.074-4.468-4.627-4.468zm0 7.165c-1.398 0-2.602-1.121-2.602-2.708 0-1.61 1.206-2.707 2.602-2.707 1.398 0 2.601 1.097 2.601 2.707 0 1.597-1.203 2.707-2.601 2.707zm-12.013-5.8v1.89h4.687c-.144 1.06-.506 1.844-1.06 2.38-.687.665-1.747 1.388-3.616 1.388-2.88 0-5.133-2.252-5.133-5.04 0-2.79 2.253-5.041 5.133-5.041 1.555 0 2.688.594 3.53 1.354l1.384-1.34c-1.168-1.085-2.723-1.915-4.903-1.915-3.951 0-7.267 3.116-7.267 6.931 0 3.826 3.313 6.931 7.267 6.931 2.134 0 3.735-.675 5-1.948 1.29-1.249 1.698-3.011 1.698-4.433 0-.443-.035-.84-.108-1.178h-6.614c.002-.003.002.02.002.02zm49.135 1.471c-.387-1.003-1.555-2.846-3.951-2.846-2.375 0-4.349 1.81-4.349 4.467 0 2.508 1.953 4.467 4.579 4.467a4.61 4.61 0 003.842-1.982l-1.565-1.016c-.52.746-1.242 1.236-2.267 1.236-1.035 0-1.76-.456-2.242-1.354l6.169-2.474-.216-.498zm-6.29 1.493c-.05-1.726 1.384-2.603 2.409-2.603.809 0 1.482.385 1.712.945l-4.121 1.658zM89.609 31.5h2.026V18.376h-2.026V31.5zm-3.326-7.664h-.073c-.457-.526-1.325-1.003-2.434-1.003-2.301 0-4.421 1.961-4.421 4.48 0 2.509 2.11 4.446 4.421 4.446 1.096 0 1.977-.479 2.434-1.016h.073v.642c0 1.704-.941 2.623-2.458 2.623-1.241 0-2.012-.864-2.326-1.586l-1.76.712a4.4 4.4 0 004.083 2.637c2.375 0 4.387-1.354 4.387-4.656V23.1h-1.915v.736h-.01zm-2.326 6.172c-1.398 0-2.566-1.132-2.566-2.695 0-1.576 1.168-2.718 2.566-2.718 1.385 0 2.459 1.155 2.459 2.718.013 1.563-1.071 2.695-2.459 2.695zm26.438-11.632h-4.844V31.5h2.026v-4.97h2.82c2.242 0 4.446-1.574 4.446-4.072 0-2.497-2.196-4.082-4.448-4.082zm.059 6.321h-2.88v-4.503h2.88c1.517 0 2.375 1.212 2.375 2.251 0 1.03-.869 2.252-2.375 2.252zm12.508-1.877c-1.472 0-2.989.63-3.616 2.006l1.796.722c.386-.722 1.095-.969 1.844-.969 1.049 0 2.109.608 2.134 1.692v.139c-.363-.2-1.158-.503-2.11-.503-1.939 0-3.905 1.026-3.905 2.951 0 1.762 1.59 2.893 3.362 2.893 1.36 0 2.109-.594 2.577-1.283h.073v1.016h1.952v-5.027c0-2.341-1.795-3.637-4.107-3.637zm-.255 7.188c-.662 0-1.59-.315-1.59-1.121 0-1.016 1.158-1.401 2.145-1.401.892 0 1.314.186 1.844.442-.146 1.179-1.174 2.069-2.399 2.08zm11.485-6.908l-2.325 5.692h-.073l-2.41-5.692h-2.179l3.615 7.957-2.06 4.423h2.109l5.563-12.38h-2.24zm-18.232 8.4h2.026V18.376h-2.026V31.5z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.315 7.91c-.314.328-.495.828-.495 1.482V32.61c0 .655.181 1.155.505 1.47l.084.07L24.844 21.14v-.29L11.398 7.84l-.083.07z"
        fill="url(#prefix__paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.314 25.49l-4.48-4.338v-.304l4.48-4.339.098.058 5.3 2.917c1.517.827 1.517 2.194 0 3.032l-5.3 2.917-.098.058z"
        fill="url(#prefix__paint1_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.412 25.433L24.834 21l-13.52 13.09c.496.513 1.326.57 2.254.07l15.844-8.727z"
        fill="url(#prefix__paint2_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.412 16.567L13.568 7.853c-.928-.513-1.761-.443-2.253.07L24.834 21l4.578-4.433z"
        fill="url(#prefix__paint3_linear)"
      />
      <path
        opacity={0.2}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.314 25.339l-15.736 8.656c-.879.49-1.663.456-2.169.01l-.084.082.084.07c.506.443 1.29.48 2.17-.01l15.844-8.714-.108-.094z"
        fill="#000"
      />
      <path
        opacity={0.12}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.712 22.364l-5.411 2.975.097.094 5.3-2.917c.76-.419 1.134-.969 1.134-1.516-.046.503-.433.98-1.12 1.364z"
        fill="#000"
      />
      <path
        opacity={0.25}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.567 8.005l21.145 11.63c.687.375 1.074.865 1.133 1.365 0-.547-.373-1.097-1.133-1.516L13.567 7.853c-1.517-.84-2.747-.139-2.747 1.54v.151c0-1.68 1.23-2.37 2.747-1.54z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear"
          x1={23.639}
          y1={9.142}
          x2={2.213}
          y2={15.038}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset={0.007} stopColor="#00A1FF" />
          <stop offset={0.26} stopColor="#00BEFF" />
          <stop offset={0.512} stopColor="#00D2FF" />
          <stop offset={0.76} stopColor="#00DFFF" />
          <stop offset={1} stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear"
          x1={36.691}
          y1={21}
          x2={10.451}
          y2={21}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset={0.409} stopColor="#FFBD00" />
          <stop offset={0.775} stopColor="orange" />
          <stop offset={1} stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear"
          x1={26.922}
          y1={23.412}
          x2={10.457}
          y2={52.034}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset={1} stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="prefix__paint3_linear"
          x1={7.911}
          y1={0.188}
          x2={15.256}
          y2={12.97}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset={0.069} stopColor="#2DA771" />
          <stop offset={0.476} stopColor="#15CF74" />
          <stop offset={0.801} stopColor="#06E775" />
          <stop offset={1} stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Icon
